import { Snackbar } from "@chef/components";
import { intl } from "./WeekOverviewDefault.Intl";

export const PreferenceWarningSnackbar = ({ show }: { show: boolean }) => {
  if (!show) {
    return null;
  }
  return (
    <Snackbar error showIcon className="mb-4">
      {intl.YOUR_MENU_CONTAINS_NON_COMPLIANT_PRODUCTS}
    </Snackbar>
  );
};
